// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"1e197139","455":"9042e797","977":"f160f979"}[chunkId] + ".chunk.js";
};